import { render } from "./PublishView.vue?vue&type=template&id=5d4d6ecb&scoped=true"
import script from "./PublishView.vue?vue&type=script&lang=js"
export * from "./PublishView.vue?vue&type=script&lang=js"

import "./PublishView.vue?vue&type=style&index=0&id=5d4d6ecb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4d6ecb"]])

export default __exports__